const DEFAULT_MARKUP_PERCENTAGE = 2.0

function currencyToSubunits (amount) {
  return Math.round(amount * 100)
}

function currencyConvertedAmountToSubunits (gbpAmount, currency = 'gbp', exchangeRate = null, markupPercentage = null) {
  if (!gbpAmount && gbpAmount !== 0) return null
  const gbpSubunits = currencyToSubunits(gbpAmount)
  if (currency === 'gbp') return gbpSubunits

  if (!exchangeRate) return null

  const markup = markupPercentage !== null ? markupPercentage : DEFAULT_MARKUP_PERCENTAGE

  const convertedSubunits = gbpSubunits * exchangeRate
  const markupMultiplier = 1 + (markup / 100)
  const finalAmount = convertedSubunits * markupMultiplier

  return Math.round(finalAmount)
}

export function currencyConvertedAmount (gbpAmount, currency = 'gbp', exchangeRate = null, markupPercentage = null) {
  if (!gbpAmount && gbpAmount !== 0) return null

  if (currency === 'gbp') {
    return gbpAmount
  }

  const subunits = currencyConvertedAmountToSubunits(gbpAmount, currency, exchangeRate, markupPercentage)
  if (subunits === null) return null

  return Math.round((subunits / 100) * 100) / 100
}

export function getCurrencyConversionData () {
  const exchangeRateElement = document.getElementById('vjs-exchange-rate')
  const markupElement = document.getElementById('vjs-exchange-markup-percentage')

  return {
    exchangeRate: exchangeRateElement ? parseFloat(exchangeRateElement.value) : null,
    markupPercentage: markupElement ? parseFloat(markupElement.value) : DEFAULT_MARKUP_PERCENTAGE
  }
}

// TODO: To be refactored into a Currency registry later - centralise change when adding locale / currency
export function formatConvertedCurrencyAmount (gbpAmount, currency = 'gbp', exchangeRate = null, markupPercentage = null) {
  if ((exchangeRate === null || markupPercentage === null) && currency !== 'gbp') {
    const conversionData = getCurrencyConversionData()
    exchangeRate = exchangeRate || conversionData.exchangeRate
    markupPercentage = markupPercentage !== null ? markupPercentage : conversionData.markupPercentage
  }

  const convertedAmount = currencyConvertedAmount(gbpAmount, currency, exchangeRate, markupPercentage)

  if (convertedAmount === null) return ''

  if (currency === 'eur') {
    const formatted = convertedAmount.toLocaleString('nl-NL', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })
    return '€' + formatted + ',-'
  }

  if (currency === 'usd') {
    return '$' + convertedAmount.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })
  }

  return '£' + convertedAmount.toFixed(2)
}
